import { Component, OnInit } from '@angular/core';
import { SocketService } from '../shared/socket.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LoggerService } from '../shared/logger.service';
// import { io, Socket } from 'socket.io-client';
import io from 'socket.io-client';
import { environment } from '../../environments/environment';

const { apiUrl } = environment;

@Component({
  selector: 'app-chat',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule
  ],
  templateUrl: './chat.component.html',
  styleUrl: './chat.component.scss'
})
export class ChatComponent implements OnInit {
  message: string = 'Wally Init';
  messages: string[] = [];
  private socket: any;
  connectionStatus: string = 'Connecting...';

  constructor(private socketService: SocketService,
    private logger: LoggerService
  ) { }

  ngOnInit(): void {
    this.logger.debug(`ngOnInit...`);
    // this.socketService.joinMessageRoom();
    // this.socket = io(`${apiUrl}/`, {
    //   transports: ['websocket'] // ['websocket']
    // });

    // this.socket.on('connect', () => {
    //   this.connectionStatus = `Connected! Socket ID: ${this.socket?.id}`;
    //   console.log('Connected to Socket.IO server:', this.socket?.id);
    //   // You can emit events or perform actions here after connection
    //   this.socket?.emit('clientConnected', 'Hello from Angular client!');
    // });

    // this.socket.on('disconnect', () => {
    //   this.connectionStatus = 'Disconnected from server.';
    //   console.log('Disconnected from Socket.IO server.');
    // });

    // this.socket.on('connect_error', (error:any) => {
    //   this.connectionStatus = `Connection Error: ${error.message}`;
    //   console.error('Socket.IO connection error:', error);
    // });

    this.socketService.onMessage()
      .subscribe((message: string | unknown) => {
        this.logger.debug(`onMessage:message: `, message);
        this.messages.push((message as string));
      });

    this.socketService.onBlast()
      .subscribe((message: string | unknown) => {
        this.logger.debug(`onBlast:message: `, message);
        this.messages.push((message as string));
      });

    this.socketService.onRefresh()
      .subscribe((args: any | unknown) => {
        this.logger.debug(`onRefresh:args: `, args);
        this.messages.push(JSON.stringify(args));
      });
    // // this.socketService.onConnection().subscribe((socket: any) => {
    // //   this.logger.debug(`onconnection: `, socket);
    // // });

  }

  sendMessage(): void {
    this.socketService.sendMessage(this.message);
    this.message = '';
  }
}
